import { type ReportAccessGrantConstructor } from '@webapp/platform/iam/entities/ReportAccessGrant'
import { type ReportAccessGrantApiModel } from '../api-models/ReportAccessGrantApiModel'

export const mapReportAccessGrantApiModel = (
  grant: ReportAccessGrantApiModel
): ReportAccessGrantConstructor => ({
  id: grant.id,
  userFirstName: grant.user.firstName,
  userLastName: grant.user.lastName,
})
